import React, { useContext, useEffect, useState } from 'react';

import './HerramientasSubtabla.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBackspace } from "@fortawesome/free-solid-svg-icons";

import SelectControl from '../SelecControl/SelectControl.jsx';

import FormHerramienta from '../FormHerramienta/FormHerramienta.js';

import herramientaContext from '../../context/herramientaContext/herramientaContex.js';
import { estructuraHerramienta } from '../../utils/estructuras.js';
import { SECUNDARY_COLOR } from '../../constants/colors';

const HerramientasSubtabla = ({herramientas, setState, tablaSeleccionada, tDocID='', checkboxMode=false}) =>{

    const [data,setData] = useState('');
    const [showAddHerramienta,setShowAddHerramienta] = useState(false);
    const [nuevoEditado, setNuevoEditado] = useState("Agregar");
    const [indexToUpdate,setIndexToUpdate] = useState(-1);
    const [options,setOptions] = useState([]);

    const hContext = useContext(herramientaContext);
    const {actualizarHerramientaLista,herramientaIDLista} = hContext;

    const minimizar = () => {
        setShowAddHerramienta(false);
    }

    const createOptions = () => {
        const copyHerramientas = JSON.stringify(herramientaIDLista)
        const herramientasList = JSON.parse(copyHerramientas)
        let optionsH = [];
        if(herramientasList.length > 0){
            optionsH = herramientasList.map((h) => {return {
                label:h.name, value: h.codHerramienta, id: h['_id'], name:h.name
            }})
        }
        setOptions({opcionesHerramientas:optionsH});
    }

    // === Funciones modo tradicional (dropdown) ===
    const handleChangeHerramientas = (herramienta = {},i,textAdic = undefined) => {
        setState((prevState) => {
            let preHerramientas = prevState.herramientas.slice();
            const copyHerramientas = JSON.stringify(preHerramientas)
            const herramientasArr = JSON.parse(copyHerramientas)

            if(textAdic != undefined && Object.keys(herramienta).length == 0){
                if(herramientasArr[i].value !== ''){
                    herramientasArr[i].textAdic = textAdic;
                }
                let newState = {...prevState,['herramientas']:herramientasArr};
                return newState;
            }else{
                if(Object.keys(herramienta).length == 0){
                    herramientasArr.splice(i,1);
                }
                else if(herramientasArr[i].value !== ''){
                    herramientasArr[i] = herramienta;
                    herramientasArr[i].textAdic = "";
                }else{
                    herramientasArr[i] = herramienta;
                    herramientasArr[i].textAdic = "";
                    herramientasArr.push({...estructuraHerramienta});
                }
                let newState = {...prevState,['herramientas']:herramientasArr};
                return newState;
            }
        })
    }

    const handleDeleteHerramienta = (herramienta,index) => {
        setState((prevState) => {
            let herramientasArr = prevState.herramientas.slice();
            if(herramientasArr.length > 0 && index > -1 && herramienta.label !== ''){
                herramientasArr = prevState.herramientas.filter((h,i) => i !== index);
            }
            let newState = {...prevState,['herramientas']:herramientasArr};
            return newState;
        });
    }

    // === Funciones modo checkbox ===
    const findCheckedHerramienta = (catalogHerramienta) => {
        if(!herramientas || herramientas.length === 0) return null;
        return herramientas.find(h => h.value === catalogHerramienta.codHerramienta || h.codHerramienta === catalogHerramienta.codHerramienta);
    }

    const handleToggleHerramienta = (catalogHerramienta, checked) => {
        setState((prevState) => {
            let currentHerramientas = prevState.herramientas ? prevState.herramientas.filter(h => h.label !== '') : [];

            if(checked) {
                const existing = currentHerramientas.find(h => h.value === catalogHerramienta.codHerramienta || h.codHerramienta === catalogHerramienta.codHerramienta);
                if(!existing) {
                    currentHerramientas.push({
                        value: catalogHerramienta.codHerramienta,
                        label: catalogHerramienta.name,
                        id: catalogHerramienta._id,
                        codHerramienta: catalogHerramienta.codHerramienta,
                        name: catalogHerramienta.name,
                        textAdic: ''
                    });
                }
            } else {
                currentHerramientas = currentHerramientas.filter(h =>
                    h.value !== catalogHerramienta.codHerramienta && h.codHerramienta !== catalogHerramienta.codHerramienta
                );
            }

            return {...prevState, herramientas: currentHerramientas};
        });
    }

    const handleChangeTextAdic = (catalogHerramienta, textAdic) => {
        setState((prevState) => {
            let currentHerramientas = prevState.herramientas ? prevState.herramientas.slice() : [];
            const index = currentHerramientas.findIndex(h => h.value === catalogHerramienta.codHerramienta || h.codHerramienta === catalogHerramienta.codHerramienta);
            if(index > -1) {
                currentHerramientas[index] = {...currentHerramientas[index], textAdic};
            }
            return {...prevState, herramientas: currentHerramientas};
        });
    }

    const handleChangeHerramientasCheckbox = (herramienta = {}, index) => {
        if(Object.keys(herramienta).length === 0) {
            setState((prevState) => {
                let currentHerramientas = prevState.herramientas ? prevState.herramientas.slice() : [];
                currentHerramientas = currentHerramientas.filter(h =>
                    h.value !== data.value && h.codHerramienta !== data.codHerramienta
                );
                return {...prevState, herramientas: currentHerramientas};
            });
        } else {
            setState((prevState) => {
                let currentHerramientas = prevState.herramientas ? prevState.herramientas.slice() : [];
                const idx = currentHerramientas.findIndex(h => h.id === herramienta.id || h.value === herramienta.value);
                if(idx > -1) {
                    currentHerramientas[idx] = {...currentHerramientas[idx], ...herramienta};
                }
                return {...prevState, herramientas: currentHerramientas};
            });
        }
    }

    useEffect(()=>{
        createOptions();
    },[herramientaIDLista])

    return <div className={`${(tablaSeleccionada != 'herramientas') && 'inactive'} herramientasDiv`}>
    <label>Herramientas</label>
    <div className="herramientasXtransactionDoc">
        {checkboxMode ? (
            // === MODO CHECKBOX ===
            <>
            {(!herramientaIDLista || herramientaIDLista.length === 0) ? <div style={{display:'flex', alignItems:'center', gap:'0.5rem'}}>
                <h5 style={{marginBottom:0}}>No hay herramientas cargadas en el sistema.</h5>
                <button className="button-add-form" style={{backgroundColor: SECUNDARY_COLOR, borderRadius:'5px', padding:'0.25rem 1rem', fontSize:'1.2rem'}} onClick={() => { setNuevoEditado("Agregar"); setData(''); setShowAddHerramienta(true); }}>+</button>
            </div> :
            herramientaIDLista.map((catalogHerramienta, i) => {
                const checkedHerramienta = findCheckedHerramienta(catalogHerramienta);
                const checked = !!checkedHerramienta;
                return <div className="herramientaDiv" key={`${catalogHerramienta.codHerramienta}-${i}`}>

                    <SelectControl placeholder={"Seleccione una Herramienta..."} modo={"Nuevo"} setShowAdd={setShowAddHerramienta} idSelect={"herramienta"} handleChengeSelect={()=>{}} optionsSelect={options.opcionesHerramientas} valueSeleccionada={{value: catalogHerramienta.codHerramienta, label: catalogHerramienta.name, id: catalogHerramienta._id, name: catalogHerramienta.name}} tipo={'herramientaOT'} selectSelect={()=>{}} setData={setData} index={i} setNuevoEditado={setNuevoEditado} setIndexToUpdate={setIndexToUpdate} />

                    <label className='customCheckbox'>
                        <input value={checked} className='checkboxTask' type='checkbox' checked={checked} onChange={(e) => handleToggleHerramienta(catalogHerramienta, e.target.checked)}/>
                        <span className={`${checked ? 'checked' : ''}`}></span>
                    </label>

                    <input className="inputTextAdic" name="textAdic" value={checked ? (checkedHerramienta.textAdic || '') : ''} onChange={(e) => handleChangeTextAdic(catalogHerramienta, e.target.value)} placeholder="Ingrese texto adicional..." disabled={!checked}/>
                </div>
            })
            }
            </>
        ) : (
            // === MODO TRADICIONAL (DROPDOWN) ===
            <>
            {(herramientas == undefined) ? <h5>Cargando Herramientas...</h5> :
            herramientas.length > 0 && herramientas.map((herramienta,i) =><div className="herramientaDiv" key={`${herramienta.codHerramienta}-${i}`}>
                <FontAwesomeIcon icon={faBackspace} color="red" style={{ width: '80px', height: '40px', marginTop: "5px", cursor: "pointer" }} onClick={()=>handleDeleteHerramienta(herramienta,i)} />

                <SelectControl placeholder={"Seleccione una Herramienta..."} modo={"Nuevo"} setShowAdd={setShowAddHerramienta} idSelect={"herramienta"} handleChengeSelect={handleChangeHerramientas} optionsSelect={options.opcionesHerramientas} valueSeleccionada={herramienta} tipo={'herramientaOT'} selectSelect={handleChangeHerramientas} setData={setData} index={i} setNuevoEditado={setNuevoEditado} setIndexToUpdate={setIndexToUpdate} />

                <input className="inputTextAdic" name="textAdic" value={herramienta.textAdic} onChange={(e) => handleChangeHerramientas({},i,e.target.value)} placeholder="Ingrese texto adicional..."/>
            </div>)
            }
            </>
        )}
        {showAddHerramienta && <FormHerramienta data={data} setData={setData} minimizar={minimizar} nuevoEditado={nuevoEditado} handleChangeHerramientas={checkboxMode ? handleChangeHerramientasCheckbox : handleChangeHerramientas} index={indexToUpdate} tDocID={tDocID}/> }
    </div>
    </div>
}

export default HerramientasSubtabla;
